/*
Copyright (c) 2024 Mahadeva Systems (https://www.thesha.co.in).

Proprietary Software License

All Rights Reserved.

This software and its source code are proprietary and confidential. Unauthorized copying, distribution, modification, or sharing of any part of this code, in any form, is strictly prohibited.

Any attempt to share, publish, sublicense, or otherwise disclose the code, in whole or in part, without explicit, written permission from the copyright holder, will result in legal action to the fullest extent permitted by law.

By using, viewing, or possessing this software, you agree to these terms.

For permissions or inquiries, contact: info@thesha.co.in
*/

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
